<div class="table-detail">
  <button mat-button class="table-detail__back" (click)="goBack()" [attr.aria-label]="backLinkLabel">
    <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
    <span>{{ backLinkLabel }}</span>
  </button>

  @if (!loading) {
    @if (notFound) {
      <div class="table-detail__empty">
        <h2>Table not found</h2>
        <p>The table you’re looking for doesn’t exist or was removed.</p>
        <button mat-flat-button color="primary" (click)="goBack()">
          <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
          Return to list
        </button>
      </div>
    }
    @if (!notFound) {
      <div class="table-detail__content">
        <div class="table-detail__header">
          <div class="table-detail__heading">
            <h1>{{ activeTableName }}</h1>
            @if (table?.description) {
              <p class="table-detail__subtitle">
                {{ table?.description }}
              </p>
            }
          </div>
          <app-aid-year [disabled]="editMode"></app-aid-year>
        </div>
        @if (isNew && editMode && newTableWizardStep === "layout" && table && tableCopy) {
          <div class="table-detail__editor-scroll" appKeyboardScrollable>
            <mat-card appearance="outlined" class="new-table-layout-card">
              <mat-card-header>
                <mat-card-title>Choose table type</mat-card-title>
              </mat-card-header>
              <mat-card-content class="new-table-layout-body">
                <p class="new-table-layout-lead">Pick how this table maps inputs to amounts. You cannot switch types after the table is created. If unsure, choose standard table.</p>

                <div class="new-table-layout-options" role="group" aria-labelledby="new-table-layout-type-label">
                  <span id="new-table-layout-type-label" class="cdk-visually-hidden">Table type</span>

                  <div class="new-table-layout-option">
                    <h3 class="new-table-layout-option-title">Standard table</h3>
                    <p class="new-table-layout-option-copy">One input (a question, calculation key, or formula). You define either numeric ranges or code lookups, then one amount per band or choice—same pattern as a classic lookup or bracket table.</p>
                    <button mat-flat-button color="primary" type="button" (click)="onNewTableStandardLayout()">Use standard table</button>
                  </div>

                  <div class="new-table-layout-option">
                    <h3 class="new-table-layout-option-title">Advanced matrix</h3>
                    <p class="new-table-layout-option-copy">Two inputs (one for rows, one for columns). Cell values are a grid: each combination of row band and column band has its own amount. Use this when the outcome depends on two factors at once.</p>
                    <button mat-stroked-button color="primary" type="button" (click)="onNewTableMatrixLayout()">Use advanced matrix</button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <div class="table-detail__wizard-actions">
              <button mat-button type="button" (click)="cancel()">Cancel</button>
            </div>
          </div>
        }
        @if (table && tableCopy && !(isNew && editMode && newTableWizardStep === "layout")) {
          @if (editMode) {
            <div class="table-detail__editor-scroll" appKeyboardScrollable>
              <app-table
                [table]="tableCopy"
                [editMode]="editMode"
                [isNew]="isNew"
                [openRowColumnInputStepOnce]="openRowColumnInputStepOnce"
                (openRowColumnInputStepConsumed)="onOpenRowColumnInputStepConsumed()"
                (edit)="startEdit()"
                (delete)="confirmDelete()"
                (saveTable)="save()"
                (cancelEdit)="cancel()"
              />
            </div>
          } @else {
            <app-table [table]="table" [editMode]="editMode" [isNew]="isNew" (edit)="startEdit()" (delete)="confirmDelete()" (saveTable)="save()" (cancelEdit)="cancel()" />
          }
        }
      </div>
    }
  } @else {
    <div class="table-detail__loading">Loading table…</div>
  }
</div>
